/*
 * @Author: your name
 * @Date: 2020-08-21 18:15:16
 * @LastEditTime: 2020-09-21 11:02:00
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\server\system.js
 */
import http from "../utils/http";
export default {
	vehicleList: function(fun) {
		http.get("/system/vehicle-list", fun)
	},
	setVehicle: function(data, fun) {
		http.put("/system/vehicle", data, fun)
	},
	addVehicle: function(data, fun) {
		http.post("/system/vehicle", data, fun)
	},
	delVehicle(id, fun) {
		http.delete("/system/vehicle/" + id, fun)
	},
	user: function(id, fun) {
		http.get("/user/" + id, fun)
	},
	configPage: function(id, fun) {
		http.get("/system/config-page", fun)
	},
	setConfig: function(data, fun) {
		http.put("/system/config/", data, fun)
	},
	setVehicleDefault: function(id, fun) {
		http.put("/system/set-vehicle-default/" + id, fun)
	},
	userPage: function(data, fun) {
		http.get("/user/page", data, fun)
	},
	editUser: function(data, fun) {
		http.put("/user", data, fun)
	},
	addUser: function(data, fun) {
		http.post("/user", data, fun)
	},
	deleteUser: function(roleId, fun) {
		http.post("/role/${roleId}", data, fun)
	},
	switchUserState: function(id, fun) {
		http.put("/switch-user-state/" + id, fun)
	},

	// 充值活动
	changeByRechargeActivity(data, fun) {
		http.put("/recharge-activities/changeByRechargeActivity", data, fun)
	},

	queryRechargeActivity(data, fun) {
		http.get("/recharge-activities/queryPage", data, fun)
	},

	addRechargeActivity(data, fun) {
		http.post("/recharge-activities/addRecharge", data, fun)
	},
	getCity(fun) {
		http.get("https://apis.map.qq.com/ws/district/v1/list", {
			key: 'AJ7BZ-LK2CD-O334S-PGYBT-Z33MT-WDBY5'
		}, fun)
	},
	getAllCar(data, fun) {
		http.get("/base-data/allCar", data, fun)
	},
	//开通加盟物流新账号
	createjoinlogistics(data, fun) {
		http.post("/st-logistics-company/open-company", data, fun)
	},
	//查询加盟物流信息
	queryjoinlogistics(data, fun) {
		http.post("/st-logistics-company/query-page", data, fun)
	},
	//更新加盟物流信息
	updatejoinlogistics(data, fun) {
		http.post("/st-logistics-company/update", data, fun)
	},
	//充值

	recharge(data, fun) {
		http.post("/st-logistics-company/top-up", data, fun)
	},
	// 查询商品列表
	productList(data, fun) {
		http.post("/st-score-goods/page", data, fun)
	},
	//新增商品
	productAddEdit(data, fun) {
		http.post("/st-score-goods/add", data, fun)
	},
	// 获取商品详情
	productDetail(id, fun) {
		http.post(`/st-score-goods/detail/${id}`, fun);
	},
	
	// 更新商品
	productUpdate(data, fun) {
		http.post("/st-score-goods/update", data, fun)
	},
	//获取商品列表
	productOrder(data, fun) {
		http.post("/st-goods-order/page", data, fun)
	},
	//更改操作状态 
	cancelOrder(data, fun) {
		http.post("/st-goods-order/update-state", data, fun)
	},
	//编辑公告
	AddEdit(data, fun){
		http.post("/st-announcement/save", data, fun)
	},
	//查询公告
	getNotice(data, fun) {
		http.post("/st-announcement/page", data, fun)
	},
	//删除公告
	deleteNotice(id, fun) {
		http.delete("/st-announcement/delete/" + id, fun)
	},
	//物流软件账户新增
	addLogisticsUser: function(data, fun) {
		http.post("/logistics-software-company/open-company", data, fun)
	},
	//物流软件查询
	LogisticsUserPage: function(data, fun) {
		http.post("/logistics-software-company/page", data, fun)
	},
	//更改续费信息
	changeFreeInfoData: function (data, fun) {
		http.put("/logistics-software-company/update-expiry-info", data, fun)
	},
	//物流软件短信增值服务
	addMessageService: function(data, fun) {
		http.post("/st-logistics-vas/add", data, fun)
	},
	//物流软件短信增值服务
	deleteMessageService: function(data, fun) {
		http.delete("/st-logistics-vas/delete", data, fun)
	},
	//物流软件短信是否启用
	isStartMessageService: function (data, fun) {
		http.post("/logistics-software-company/update-valid", data, fun)
	},
	//进销存软件账户查询
	jxcQueryByPage: function(data, fun) {
		http.post("/jxc-software-company/page", data, fun)
	},
	//进销存软件账户新增
	addJxcAccount: function(data, fun) {
		http.post("/jxc-software-company/open-company", data, fun)
	},
}
